export default function ResetCheckbox(list) {
  const checkboxList = list;

  const tabs = document.querySelectorAll(".js-tab");
  const checkboxContainer = checkboxList[0].closest(".js-tab-content");

  for (let i = 0, len = tabs.length; i < len; i++) {
    const tab = tabs[i];

    tab.addEventListener("click", function resetChecked() {
      if (!checkboxContainer.classList.contains("is-show")) {
        for (let j = 0, leng = checkboxList.length; j < leng; j++) {
          const checkboxItem = checkboxList[j];

          checkboxItem.checked = false;
        }
      }
    });
  }
}
